export default __webpack_public_path__ + "static/media/pfp-pink.e84da001.svg";